<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {}
}
</script>
<style lang="less" scoped>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  overflow: hidden;
  width: 100%;
  height: 100vh;
}
</style>
